import { entities, formatters, notUndefinedOrNull } from "@fraction/shared";
import _ from "lodash";
import { Avatar } from "src/components";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "src/components/ui/select";

export function SalesPersonSelect({
  onValueChange,
  className,
  value,
  employees,
}: {
  value?: string;
  onValueChange?: (value: string | null) => void;
  className?: string;
  employees?: entities.InternalEmployee[];
}) {
  const regions = _.uniq(
    employees
      ?.map((e) => e.licensedRegions)
      .flat()
      .filter(notUndefinedOrNull) || []
  );

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder="BDM select" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Overall</SelectLabel>
          <SelectItem value="all">All Sales People</SelectItem>
          {regions?.map((region) => (
            <SelectItem key={region} value={`region:${region}`}>
              {_.startCase(region)} BDMs
            </SelectItem>
          ))}
          <SelectLabel>Specific BDM</SelectLabel>
          {employees?.map((e) => (
            <SelectItem key={e.id} value={e.id!}>
              <div className="flex flex-row gap-x-2 items-center">
                <Avatar
                  className="h-[25px] min-h-[25px] w-[25px] min-w-[25px]"
                  src={e?.photoLink}
                  title={formatters.user.userName(e?.user)}
                >
                  {formatters.user.userName(e?.user) || "??"}
                </Avatar>
                <div className="ml-2 text-left text-xs">
                  <b>{formatters.user.userName(e?.user)}</b>
                  <p className="text-xs">{e?.user?.email}</p>
                </div>
              </div>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
